import { globalFetch } from "foundation/js/api"

let checkoutState = null

const sessionStorageCheckoutState = sessionStorage.getItem('checkoutState')
if(sessionStorageCheckoutState) {
    const retrievedState = JSON.parse(sessionStorageCheckoutState)
    if(retrievedState && retrievedState.checkoutSteps) {
        checkoutState = retrievedState
    }
}

// 
// Helper functions
// 
function _getCreateOrderData(state) {
    const p = state.purchaseData
    let paymentMethod = (() => {
        switch (p.payment.paymentData.paymentMethod?.toString()) {
            case "1": return "MobilePay";
            case "2": return "PaymentCard";
            case "3": return "Invoice"; 
            default: return "NoPayment"
        }})()

    let customerType = (() => {
        switch (p.invoice.userInformation.customerType) {
            case "publicInstitution": return "public";
            case "frivillige": return "private"; // TODO sle: Remove this hack when CRM value for frivillige is known.
            default: return p.invoice.userInformation.customerType; 
        }})()
        
    let shippingMethod = (() => {
        switch (state.stepTwo.activeDeliveryType) { 
            case "home": return "homeDelivery";
            case "pickUp": return "servicePointDelivery";
            default: throw new Error('No delivery type selected')
        }})()

    let companyOrInstitutionName = customerType == "company"
        ? p.invoice.company.companyName
        : customerType == "public" 
            ? p.invoice.public.publicInstitutionNameInput
            : null

    let companyDepartmentOrInstitutionDepartment = customerType == "company"
        ? p.invoice.company.companyDepartment
        : customerType == "public" 
            ? p.invoice.public.publicInstitutionDepartmentOrContact
            : null

    let deliveryAddress = null
    if (shippingMethod == "servicePointDelivery") {
        deliveryAddress = {
            addressOption: "Delivery",
            firstName: "", 
            lastName: "",
            addressLine1: state.stepTwo.pickUpAddressData.addressLine, 
            zipCode: state.stepTwo.pickUpAddressData.postalCode, 
            city: state.stepTwo.pickUpAddressData.city, 
            companyName: state.stepTwo.pickUpAddressData.name,
            department: null,
            servicePointId: state.stepTwo.pickUpAddressData?.id
        }
    }
    else if (state.stepTwo.showDifferentAddress)
    {
        deliveryAddress = { 
            addressOption: "Delivery",
            firstName: p.delivery.deliveryAddress.contactFirstName,
            lastName: p.delivery.deliveryAddress.contactLastName,
            addressLine1: p.delivery.deliveryAddress.addressLine,
            zipCode: p.delivery.deliveryAddress.postalCode,
            city: p.delivery.deliveryAddress.city,
            companyName: p.delivery.deliveryAddress.deliveryName,
            department: p.delivery.deliveryAddress.deliveryDepartment
        }
    }

    // purchaseData mapping to BE format
    return {
        customerType,
        shippingMethod, 
        reference: p.invoice?.public?.publicInstitutionUserId ?? null,
        publicInstitutionEan: p.invoice?.public?.publicInstitutionEan ?? null,
        companyCvr: p.invoice?.company?.companyCvr ?? null,
        invoiceAddress: {
            addressOption: "Invoice",
            firstName: p.invoice.userInformation.contactFirstName,
            lastName: p.invoice.userInformation.contactLastName,
            addressLine1: p.invoice.invoiceAddress.addressLine,
            zipCode: p.invoice.invoiceAddress.postalCode,
            city: p.invoice.invoiceAddress.city,
            phone: p.invoice.userInformation.mobilePhone,
            email: p.invoice.userInformation.email,
            companyName: companyOrInstitutionName,
            department: companyDepartmentOrInstitutionDepartment
        },
        deliveryAddress,
        payment: {
            paymentMethod,
            bankInformation: {
                bankRegistrationNumber: p.payment.paymentData.pbsData?.reg,
                bankAccountNumber: p.payment.paymentData.pbsData?.acc
            }
        }
    } 
}

function _getCreateOrderDataWithUdlaansvare(state) {
    const udlaansData = state.purchaseData.udlaansData;

    return {
        ..._getCreateOrderData(state),
        udlaansData: {
            startDate: udlaansData?.startDate,
            endDate: udlaansData?.endDate,
            comment: udlaansData?.comment
        }
    }
}


const checkoutStore = {
    namespaced: true,
    // here we either get sessionStorage saved state or default if falsy
    state: {
        ...checkoutState ?? {
            isSubmitting: false,
            checkoutSteps: [
                { "stepNumber": 1, "stepTitle": "Dine oplysninger", "active": true, "beenFilled": false },
                { "stepNumber": 2, "stepTitle": "Levering", "active": false, "beenFilled": false  },
                { "stepNumber": 3, "stepTitle": "Godkend og betal", "active": false, "beenFilled": false  },
                { "stepNumber": 4, "stepTitle": "Kvittering", "active": false, "beenFilled": false }
            ],
            stepOne: {
            },
            stepTwo: {
                showDifferentAddress: false,
                showPickUpAddresses: true,
                differentAddressData: {
                    addressLine: '',
                    postalCode: '',
                    city: '',
                    contactFirstName: '',
                    contactLastName: '',
                    deliveryName: '',
                    deliveryDepartment: ''
                },
                deliveryDataValidationSuccess: true,
                pickUpAddressData: {},
                pickUpAddresses: [],
                activeDeliveryType: 'pickUp',
                activeDeliveryAddress: {}
            },
            stepThree: {
                paymentData: {},
                paymentDataValidationSuccess: false,
                activePaymentMethod: ''
            },
            receipt: false,
            purchaseData: {
                invoice: {
                    invoiceAddress: {
                        addressLine1: '',
                        postalCode: '',
                        city: '',
                    },
                    userInformation: {
                        mobilePhone: '',
                        email: '',
                        contactFirstName: '',
                        contactLastName: '',
                        customerType: 'private',
                    },
                    // company inputs
                    company: {
                        companyName: '',
                        companyDepartment: '',
                        companyCvr: ''
                    },
                    // public institution inputs
                    public: {
                        publicInstitutionNameInput: '', 
                        publicInstitutionDepartmentOrContact: '', 
                        publicInstitutionUserId: '',
                        publicInstitutionEan: ''
                    },
                    udlaanData: {
                        startDate: '',
                        endDate: '',
                        comment: ''
                    }
                },
                delivery: {
                    // this should be the active one set in step two
                    deliveryAddress: {
                        addressLine: '',
                        postalCode: '',
                        city: '',
                        // if different address also:
                        contactFirstName: ' ',
                        contactLastName: ' ',
                        // or if pickUpAddress also:
                        id: '',
                        name: '',
                        latitude: 0,
                        longitude: 0,
                        deliveryName: '',
                        deliveryDepartment: ''
                    }
                },
                udlaansData: {
                    startDate: null,
                    endDate: null,
                    comment: null,
                },
                payment: {
                    terms: '',
                    paymentData: ''
                }
            },
            error_overlay_scope: undefined
        }, ...{
            isSubmissionError: false,
            submissionErrorMessage: '',
        }
    },
    mutations: {
        set_submission_error(state, payload) {
            state.isSubmissionError = payload.hasError
            state.submissionErrorMessage = payload.error.errorMessage
        },
        set_checkout_steps(state, payload) {
            state.checkoutSteps = payload
        },
        set_udlaans_data(state, payload) {
            state.purchaseData.udlaansData = payload
            // update session storage
            setStateInSessionStorage()
        },
        set_service_points(state, payload) {
            const stepTwo = Object.assign({}, state.stepTwo)
            var servicePoints = payload.map(servicePoint => {
                servicePoint.id = servicePoint.servicePointId
                return servicePoint
            })
            stepTwo.pickUpAddresses = servicePoints
            state.stepTwo = stepTwo
        },
        set_purchase_data_invoice(state, payload) {
            let invoice = Object.assign({}, state.purchaseData.invoice)
            invoice = payload
            state.purchaseData.invoice = invoice
            // update session storage
            setStateInSessionStorage()
        },
        set_purchase_data_delivery(state, deliveryAddress) {
            state.purchaseData.delivery.deliveryAddress = deliveryAddress
            // update session storage
            setStateInSessionStorage()
        },
        set_purchase_data_payment(state, payload) {
            let payment = Object.assign({}, state.purchaseData.payment)
            payment = { ...payment, ...payload }
            state.purchaseData.payment = payment
            // update session storage
            setStateInSessionStorage()
        },
        set_show_different_address(state, payload) {
            const stepTwo = Object.assign({}, state.stepTwo)
            stepTwo.showDifferentAddress = payload
            state.stepTwo = stepTwo
        },
        set_show_pick_up_addresses(state, payload) {
            const stepTwo = Object.assign({}, state.stepTwo)
            stepTwo.showPickUpAddresses = payload
            state.stepTwo = stepTwo
        },
        set_active_delivery_type(state, payload) {
            const stepTwo = Object.assign({}, state.stepTwo)
            stepTwo.activeDeliveryType = payload
            state.stepTwo = stepTwo
        },
        set_active_delivery_address(state, payload) {
            const stepTwo = Object.assign({}, state.stepTwo)
            stepTwo.activeDeliveryAddress = payload
            state.stepTwo = stepTwo
        },
        set_pick_up_address_data(state, payload) {
            const stepTwo = Object.assign({}, state.stepTwo)
            stepTwo.pickUpAddressData = payload
            state.stepTwo = stepTwo
        },
        clear_pick_up_address_data(state) {
            // Ensures that the pickUpAddressData is cleared when a new address is selected
            // User has to select a new address to proceed when searching for service points
            const stepTwo = Object.assign({}, state.stepTwo)
            stepTwo.pickUpAddressData = {}
            stepTwo.deliveryDataValidationSuccess = false
            state.stepTwo = stepTwo
        },
        set_different_address_data(state, payload) {    
            const stepTwo = Object.assign({}, state.stepTwo)
            stepTwo.differentAddressData = payload
            state.stepTwo = stepTwo
        },
        set_payment_data(state, payload) {
            const stepThree = Object.assign({}, state.stepThree)
            stepThree.paymentData = payload
            state.stepThree = stepThree
            // update session storage
            setStateInSessionStorage()
        },
        set_active_payment_method(state, payload) {
            const stepThree = Object.assign({}, state.stepThree)
            stepThree.activePaymentMethod = payload
            state.stepThree = stepThree
        },
        set_payment_data_validation_success(state, payload) {
            const stepThree = Object.assign({}, state.stepThree)
            stepThree.paymentDataValidationSuccess = payload
            state.stepThree = stepThree
        },
        set_delivery_data_validation_success(state, payload) {
            const stepTwo = Object.assign({}, state.stepTwo)
            stepTwo.deliveryDataValidationSuccess = !!payload
            state.stepTwo = stepTwo
        },
        complete_purchase(state) {
            state.receipt = true
        },
        set_submitting(state, isSubmitting) {
            state.isSubmitting = isSubmitting
        },
        update_checkout_step(state, {nextStepNumber}) {
            const nextStep = state.checkoutSteps?.map(step => {
                if (nextStepNumber) {

                    if (step.stepNumber === nextStepNumber) {
                        return {
                            ...step,
                            active: true
                        }
                    } else {
                        return {
                            ...step,
                            active: false
                        }
                    }

                }
            })
            // update checkoutSteps in state
            state.checkoutSteps = nextStep

            // update session storage
            setStateInSessionStorage()
        },
        update_checkout_step_been_filled(state, currentStep) {
            const steps = state.checkoutSteps?.map(step => {
                if (currentStep) {

                    if (step.stepNumber === currentStep) {
                        return {
                            ...step,
                            beenFilled: true
                        }
                    } else if (step.beenFilled === true){
                        return {
                            ...step,
                            beenFilled: true
                        }
                    } else {
                        return {
                            ...step,
                            beenFilled: false
                        }
                    }

                }
            })
            // update checkoutSteps in state
            state.checkoutSteps = steps

            // update session storage
            setStateInSessionStorage()
        }
    },
    actions: {
        fetchServicePoints(context) {
            const deliveryAddress = context.state.stepTwo.activeDeliveryAddress
            
            const url = `${document.location.origin}/${process.env.WEBSHOP_SERVICEPOINTS}?addressline=${deliveryAddress.addressLine}&zipcode=${deliveryAddress.postalCode}`;

            globalFetch(url)
                .then(res => {
                    if (res.ok) return res.json()
                    throw new Error('Unable to fetch service points')
                })
                .then(json => {
                    context.commit('set_service_points', json)
                })
                .catch(err => console.error(err))
        },
        placeOrder(context) {
            var data = _getCreateOrderData(context.state)
            const url = `${document.location.origin}/${process.env.WEBSHOP_CHECKOUT_PLACEORDER}`.replace('${pageId}', context.rootState.main.page_id)
            const headers = new Headers()

            headers.append('Content-Type', 'application/json')
            const message = {headers, method: process.env.POSTMETHOD, body: JSON.stringify(data)}
            if(process.env.POSTMETHOD == 'GET') delete message.body // Workaround to handle dev calls

            context.commit('set_submitting', true)

            globalFetch(url, message)
                .then(res => {
                    if (res.ok) return res.json()
                    throw new Error('Unable to place order; ' + res)
                })
                .then(json => {
                    if (json.hasError)
                    {
                        console.error(json.error)
                        throw new Error('Unable to place order; ' + json) // TODO 
                    }
                    window.location.href = json.continueUrl
                })
                .catch(err => {
                    context.commit('set_submitting', false)
                    console.error(err)
                })
        },
        async placeOrderFrivillige(context) {
            context.commit('set_submitting', true)

            const url = `${document.location.origin}/${process.env.FRIVILLIGE_WEBSHOP_CHECKOUT_PLACEORDER}`.replace('${pageId}', context.rootState.main.page_id)
            const data = JSON.stringify(_getCreateOrderDataWithUdlaansvare(context.state))
            const headers = new Headers()

            headers.append('Content-Type', 'application/json')
            const message = {headers, method: process.env.POSTMETHOD, body: data}

            context.commit('set_submission_error', { hasError: false, error: {} })

            globalFetch(url, message)
                .then(res => {
                    context.commit('set_submitting', false)
                    return res.json()
                })
                .then(json => {
                    if (json.hasError) {
                        context.commit('set_submitting', false)
                        context.commit('set_submission_error', json)
                        throw new Error('Unable to place order; ' + json.error.errorMessage)
                    }
                    window.location.href = json.continueUrl
                })
        }
    },
    getters: {

    }
}

const setStateInSessionStorage = function(){
    const stateToSave = JSON.stringify(checkoutStore.state)
    sessionStorage.setItem('checkoutState', stateToSave)
}

window.onbeforeunload = () => {
    setStateInSessionStorage()
}

export default checkoutStore
